import React from 'react'
import styled, { css } from 'styled-components'
import { TABLET, MEDIUM } from '@streamr/streamr-layout/styled'

import Item from './Item'
import ScrollSuppressor from '~shared/ScrollSuppressor'

const Container = styled.div``

const Backdrop = styled.div`
    background-color: #ffffff;
    height: 100%;
    left: 0;
    opacity: 1;
    position: absolute;
    top: 0;
    width: 100%;
`

const Outer = styled.div`
    align-items: flex-end;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    min-height: 100%;
    overflow: auto;
    padding: 0;
    pointer-events: none;
    position: relative;
    width: 100%;

    @media (min-width: ${TABLET}px) {
        align-items: center;
        padding: 0 80px;
    }
`

const ContentWrapper = styled.div`
    width: 100%;
    overflow: auto;
    height: 100%;
`

const SpaceWrapper = styled.div`
    padding: 80px 0 0;
    width: 100%;

    @media (min-width: ${TABLET}px) {
        padding: 80px 0;
    }
`

const Inner = styled.div`
    background-color: #ffffff;
    border-radius: 4px 4px 0 0;
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 736px;
    pointer-events: auto;
    padding: 56px 24px 40px;
    width: 100%;

    @media (min-width: ${TABLET}px) {
        border-radius: 4px;
        padding: 32px 48px 48px;
    }
`

const CloseButton = styled.button`
    appearance: none;
    background: none;
    border: 0;
    box-sizing: content-box;
    padding: 32px 48px;
    position: absolute;
    right: 0;
    top: 0;

    svg {
        display: block;
    }
`

const Header = styled.h1`
    flex-grow: 1;
    font-weight: ${MEDIUM};
    font-size: 20px;
    line-height: 24px;
    margin: 0 0 24px 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #0C009A;
`

const List = styled.div`
    display: grid;
    grid-auto-flow: row;
    grid-row-gap: 16px;

    ${Item} {
        padding-left: 32px;
    }
`

const CloseIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 1 1 15M1 1l14 14" stroke="#0C009A" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
)

const UnstyledSelectChainModal = ({
    className,
    close,
    shown,
    items,
    selectedChain,
    onChainSelected,
}) => (
    <Container className={className}>
        <ScrollSuppressor supress={!!shown} />
        <Backdrop onClick={close} />
        <ContentWrapper>
            <Outer>
                <SpaceWrapper>
                    <Inner>
                        <Header>
                            Select a chain
                        </Header>
                        <CloseButton type="button" onClick={close}>
                            <CloseIcon />
                        </CloseButton>
                        <List>
                            {items.map((chain) => (
                                <Item
                                    key={chain.id}
                                    chain={chain}
                                    isSelected={chain.id === selectedChain}
                                    onClick={() => {
                                        onChainSelected(chain.id)
                                        close()
                                    }}
                                />
                            ))}
                        </List>
                    </Inner>
                </SpaceWrapper>
            </Outer>
        </ContentWrapper>
    </Container>
)

const SelectChainModal = styled(UnstyledSelectChainModal)`
    color: #0c009a;
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    visibility: hidden;
    width: 100%;
    z-index: 9999;
    transition: 0.3s;
    transition-property: visibility, opacity;
    transition-delay: 0.3s, 0s;

    ${Inner} {
        transform: translateY(5%);
        transition: 0.3s transform;
    }

    ${({ shown }) => !!shown && css`
        opacity: 1;
        pointer-events: auto;
        transition-delay: 0s;
        transition-duration: 0.1s;
        visibility: visible;

        ${Inner} {
            transform: translateY(0);
            transition-duration: 0.1s;
        }
    `}
`

export default SelectChainModal
